import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            )}
            {isLast ? (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            ) : item.href ? (
              <Link to={item.href} className="hover:text-primary-600 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span>{item.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}

export function getBreadcrumbForCategory(slug: string): BreadcrumbItem[] {
  const cat = categories.find((c) => c.slug === slug);
  return [
    { label: '首页', href: '/' },
    { label: cat ? cat.name : '分类' },
  ];
}

export function getBreadcrumbForArticle(articleId: string, catName: string, catSlug: string, title: string): BreadcrumbItem[] {
  return [
    { label: '首页', href: '/' },
    { label: catName, href: `/category/${catSlug}` },
    { label: title },
  ];
}

export function getBreadcrumbForAbout(): BreadcrumbItem[] {
  return [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];
}